

const nonSpecSymptomsList=
[
    {symptom:"weightLoss",
    displayAs: "Weight Loss",
    questionGroup:"weightLoss"
    },

    {symptom:"fatigue",
    displayAs:"Fatigue",
    questionGroup:"duration"},

    {symptom:"pallor",
    displayAs:"Pallor",
    questionGroup:"duration"},

    {symptom:"fever",
    displayAs:"Unexplained fever",
    questionGroup:"fever"},

    {symptom:"infection",
    displayAs:"Persistent / recurrent infection",
    questionGroup:"siteAndDuration"},

    {symptom: "lymphadenopathy",
    displayAs: "Generalised lymphadenopathy",
    questionGroup:"lymphNode"},

    {symptom: "bleeding",
    displayAs: "Unexplained bleeding (poss haematological)",
    questionGroup:"bleeding"},

    {symptom:"jaundice",
    displayAs:"Jaundice",
    questionGroup:"jaundice"
    },

    {symptom:"nightSweats",
    displayAs:"Night sweats",
    questionGroup:"duration"},

    {symptom:"diabetes",
    displayAs: "New-onset Diabetes",
    questionGroup:"diabetes"},

    {symptom:"dvt",
    displayAs:"Deep vein thrombosis",
    questionGroup:"dvt"},

    {symptom: "malaise",
    displayAs: "Malaise",
    questionGroup:"duration"},

    {symptom: "childConcern",
    displayAs: "Persistent concern (children under 15)",
    questionGroup:"childConcern"}

]


export default  nonSpecSymptomsList